import { render, staticRenderFns } from "./SegmentStackedBar.vue?vue&type=template&id=3a31be15&"
import script from "./SegmentStackedBar.vue?vue&type=script&lang=js&"
export * from "./SegmentStackedBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports